module.exports = __webpack_public_path__ + "img/sintesis.17792ef8.svg";